// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OBLF","actions":"styles_actions__29fE0","error":"styles_error__qO8OF","message":"styles_message__VTY4H"};